
<template>
    
    <div class="createOrder">
        <div class="loadingModal" v-if="isLoading">
            <div class="loader" ></div>
        </div>
        <div class="rightSide">
            <div class="header">
                <span>יצירת הזמנה חדשה</span>
                <span class="orderNum">#{{ counter.orderNumber }}</span>
        </div>
        <!-- <div class="cartbox">
            <div class="cartHeader">
                    סל הקניות
            </div>
                <div v-for="product in cart" class="ProductLine">
                    
                <span class="name">{{ product.Data.Name }} </span>
                <span class="price"> ₪{{ product.Data.Price }} </span>
                </div>
                <div class="totalPrice">
                        <span class="text">סה"כ לתשלום</span>
                        <span class="total"> ₪{{totalOrderPrice}}</span>
                </div>

        </div> -->
        <div class="steps">
            <ul class="subMenu"> 
                <li class="listItem" :class="[activeItemBar == 1 ? 'activeItem' : 'listItem']" @click="activeItemBar = 1">פרטי הלקוח</li>
                <li class="listItem" :class="[activeItemBar == 2 ? 'activeItem' : 'listItem']" @click="activeItemBar = 2">פרטי ההזמנה</li>
                <li class="listItem" :class="[activeItemBar == 3 ? 'activeItem' : 'listItem']" @click="activeItemBar = 3">העלאת תמונות</li>
                <li class="listItem" :class="[activeItemBar == 4 ? 'activeItem' : 'listItem']" @click="activeItemBar = 4">שיטת תשלום</li>
            </ul>
        </div>
        <div class="boxStyle" v-if="activeItemBar == 1">
            <div class="input-field-beta">
                <label> שם מלא</label>
                <input type="text" placeholder="נא להכנס את שם הלקוח " v-model="fullname">
            </div>
            <div class="input-field-beta">
                <label> מספר הטלפון</label>
                <input type="text" placeholder="נא להכנס את מספר הטלפון " v-model="phoneNumber"> 
            </div>
            
            <!-- <footer></footer> -->
        </div>
        <div class="boxStyle" v-if="activeItemBar == 2">
            <div class="input-field-beta">
                <label> תאריך</label>
                <input type="date" v-model="dateOrder">
            </div>
            <div class="input-field-beta">
                <label> יום</label>
                <select  class="col-3" v-model="dayOrder">
                    <option value="" selected>בחר יום</option>
                    <option value="ראשון">ראשון</option>
                    <option value="שני ">שני</option>
                    <option value="שלישי">שלישי</option>
                    <option value="רביעי">רביעי</option>
                    <option value="חמישי">חמישי </option>
                    <option value="שישי">שישי</option>
                    <option value="שבת">שבת</option>
                </select>
            </div>
            <div class="input-field-beta">
                <label> שעה</label>
                <select  class="col-3" v-model="timeOrder">
                    <option value="" selected>בחר שעה</option>
                    <option value="09:00">09:00</option>
                    <option value="09:30">09:30</option>
                    <option value="10:00">10:00</option>
                    <option value="10:30">10:30</option>
                    <option value="11:00">11:00 </option>
                    <option value="11:30">11:30</option>
                    <option value="12:00">12:00</option>
                    <option value="12:30">12:30</option>
                    <option value="13:00">13:00</option>
                    <option value="13:30">13:30</option>
                    <option value="14:00">14:00</option>
                    <option value="14:30">14:30 </option>
                    <option value="15:00">15:00</option>
                    <option value="15:30">15:30</option>
                    <option value="16:00">16:00</option>
                    <option value="16:30">16:30</option>
                    <option value="17:00">17:00</option>
                    <option value="17:30">17:30</option>
                    <option value="18:00">18:00 </option>
                    <option value="18:30">18:30</option>
                    <option value="19:00">19:00</option>
                    <option value="19:30">19:30</option>
                    <option value="20:00">20:00</option>
                    <option value="20:30">20:30</option>
                    <option value="21:00">21:00 </option>
                    <option value="21:30">21:30</option>
                </select>
                <!-- <input type="time" v-model="timeOrder" value="15:00"> -->
            </div>
            
        </div>
        <div class="categories" v-if="activeItemBar == 2">
            <div class="catHeader">
                <span>בחר קטגוריה</span>
            </div>
            <div class="collection">
                <div class="category" @click="loadProductsToOrder()">
                    <span>עוגות מרובעות</span>
                </div>
                <div class="category" @click="loadCircleCakes()">
                    <span>עוגות עגולות</span>
                </div>
                <div class="category" @click="loadBiscuit()">
                    <span>עוגיות</span>
                </div>
                <div class="category" @click="loadPasim()">
                    <span>פסים</span>
                </div>
                <div class="category" @click="loadCoufsaot()">
                    <span>קופסאות</span>
                </div>
                <div class="category" @click="loadMghashim()"><span>מגשים</span></div>
                <div class="category" @click="loadOneUse()"><span>חד פעמי</span></div>
                <div class="category" @click="loadDrinks()"><span>שתיה</span></div>
                <div class="category" @click="loadHataifim()"><span>חטיפים</span></div>
                <div class="category" @click="loadBakingCakes()"> <span>שמרים</span> </div>
            </div>
        
        </div>
        <div class="categories" v-if="activeItemBar == 2 && activeProductsBar == 1">
            <div class="catHeader">
                <span>בחר מוצרים</span>
                <input type="text" placeholder="חפש מוצר" v-model="txtSearch">
            </div>
            <div class="collection">
                <div class="product" v-for="item in filteredProducts"  @click="addToCart(item)">
                    <span class="productName">{{item.Data.Name}}</span>
                    <span class="productPrice">₪{{item.Data.Price}}</span>
                    <span class="productQuantity"> {{item.Data.Quantity}} במלאי</span>
                </div>
            </div>
            
        </div>
        <div class="boxStyle" v-if="activeItemBar == 3">
            <div class="input-field-beta">
                <label> העלאת תמונות</label>
                <input type="file" @change="uploadImage" multiple>
            </div>
            
            <!-- <footer></footer> -->
        </div>
        <div class="uploadedPhotos" v-if="activeItemBar == 3">
            <div class="photosHeader">
                תמונות שהועלאו
            </div>
            <div class="photos">
                <div v-for="(img, i) in orderImg" :key="i">
                    <img :src="img" alt="" width="120px"> 
                    
                </div>
            </div>
        </div>

        <div class="paymentStyle" v-if="activeItemBar == 4">
            <div class="title">
                הוספת הערה להזמנה
            </div>
            <div class="paymentDiv">
                <div class="noteField">
                    <textarea  v-model="note" placeholder="הערה \ ملاحظة" > </textarea>
                    <!-- <i class="material-icons">payments</i>
                    <span class="paymentText">מזומן</span> -->
                </div>
            </div>

            <div class="title">
                סטטוס גבייה
            </div>
            <div class="paymentDiv">
                <div class="selectPayment">
                    <input type="radio" id="cash" value="שולם" v-model="paidStatus" required />
                    <i class="material-icons">price_check</i>
                    <span class="paymentText">שולם</span>
                </div>
                <div class="selectPayment">
                    <input type="radio" id="creditCard" value="לא שולם" v-model="paidStatus" required />
                    <i class="material-icons">money_off</i>
                    <span class="paymentText">לא שולם</span>
                </div>
            </div>
        </div>
        <div class="forward"  v-if="activeItemBar == 1">
            <button @click="activeItemBar  = 2">שלב הבא</button>
            <!-- <a href="#" @click="activeItemBar  = 1 "> ~ חזרה אחורה  </a> -->
        </div>
        <div class="forward"  v-if="activeItemBar == 2">
            <button @click="activeItemBar  = 3">שלב הבא</button>
            <a href="#" @click="activeItemBar  = 1 " > ~ חזרה אחורה  </a>
        </div>
        <div class="forward"  v-if="activeItemBar == 3">
            <button @click="activeItemBar  = 4">שלב הבא</button>
            <a href="#" @click="activeItemBar  = 2 " > ~ חזרה אחורה  </a>
        </div>

        <div class="forward"  v-if="activeItemBar == 4">
            <button @click="sendOrder()" >שלח הזמנה</button>
            <a href="#" @click="activeItemBar  = 3 " > ~ חזרה אחורה  </a>
        </div>


        </div>
        <div class="leftSide">
            <div class="cartbox">
                <div class="cartHeader">
                        סל הקניות
                </div>
                <div v-if="this.cart.length <= 0" style="text-align: center;padding: 70px;"> 
                    אין מוצרים בסל הקניות
                </div>
                <div v-for="(product,index) in cart" :key="index" class="ProductLine">
                    <span class="selectedQuantity"> x{{ product.selectedCount }}</span>
                    
                    
                    <!-- <input type="number" v-model="product.selectedCount"> -->
                    <span class="name">{{ product.Data.Name }} </span>
                    <span class="price"> ₪{{ product.Data.Price * product.selectedCount}} </span>
                    <div class="tools">
                        <ul>
                            <li class="removeBtn" @click="removeItem(product,index)"><span class="material-icons">clear</span></li>
                            <li class="increaseBtn" @click="addToCart(product)"><span class="material-icons">add</span></li>
                            <li class="reduceBtn" @click="reduceItem(product,index)"><span class="material-icons">remove</span></li>
                        </ul>
                    </div>
                
                </div>
                <div class="totalPrice">
                    <div class="discountLabel">
                        <label>הנחה \ שולם חלקי</label>
                        <input type="number" placeholder="הנחה" v-model.number="discount">
                    </div>

                    <span class="text">סה"כ לתשלום</span>
                    <span class="total"> ₪{{totalOrderPrice - discount}}</span>
                </div>
                

            </div>
        </div>
        
        
    </div>
        
</template>

<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
import order from '../components/Order.vue';

export default {
  name: 'CreateOrderBeta',
  components:{
    order
  },
  data () {
    return {
    orders:[],
    cart:[],
    Products:[],
    fullname:"",
    phoneNumber:"",
    timeOrder:"16:00",
    dateOrder:moment().format("YYYY-MM-DD"),
    dayOrder:"",
    priceOrder:"",
    cakeTaste:"",
    cakeSize:"",
    workerName:"",
    counter:{
        orderNumber:0,
    },
    orderImg:[],
    status:"התקבלה",
    min:1000,
    activeItemBar: 1,
    activeProductsBar: 0,
    totalOrderPrice:0,
    selectedQuantity:1,
    productObj:"",
    note:"",
    paidStatus:"",
    discount:0,
    txtSearch:'',
    isLoading:false
    }
  },
  created (){
    const m = moment();
    m.locale('he');
    console.log(m.format('LLLL'));
    let vm = this ;
    vm.loadOrders();
    vm.loadCounter();
    // vm.loadProductsToOrder();
  },
  computed: {
      filteredProducts() {
        let vm = this;
        if (vm.txtSearch.length > 0) {
          let Products = [];
          for (let i = 0; i < vm.Products.length; i++) {
            let t = vm.Products[i];
            let found = false;
            if (t.Data.Name.toUpperCase().indexOf(vm.txtSearch.toUpperCase()) > -1) {
              found = true;
            }
            if (found) {
                Products.push(t);
            }
          }
          return Products;
        } else {
          return vm.Products;
        }
      }
    },
  methods: {
  sendOrder(){
    let vm = this;
    vm.isLoading = true;
    if (vm.fullname.length > 0 && vm.dayOrder.length > 0 && vm.timeOrder.length > 0 && vm.dateOrder.length > 0 && vm.paidStatus.length > 0  ){
      let order = {
        fullname: vm.fullname,
        phoneNumber: vm.phoneNumber,
        orderImg: vm.orderImg,
        dayOrder: vm.dayOrder,
        timeOrder: vm.timeOrder,
        dateOrder: vm.dateOrder,
        totalOrderPrice: vm.totalOrderPrice,
        // cakeTaste: vm.cakeTaste,
        // cakeSize: vm.cakeSize,
        // workerName: vm.$root.loggeduser.fullName,
        status: vm.status,
        createdDate: moment().format('LLLL'),
        orderNumber: vm.counter.orderNumber,
        cart: vm.cart,
        note : vm.note,
        paidStatus : vm.paidStatus,
        discount :vm.discount,
      }
      if(vm.phoneNumber.length == 10){
        db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").set(vm.counter).then((result) => {
        vm.loadCounter();
        console.log("Counter Updated");
    }).catch((error) => {
        console.log("Error");
    })
    db.collection("orders").add(order).then(function(orderResult){   
          vm.fullname="";
          vm.phoneNumber="";
          vm.timeOrder="";
          vm.dateOrder="";
          vm.dayOrder="";
          vm.priceOrder="";
          vm.orderImg=[];
          vm.cart=[];
          vm.status="התקבלה",
          vm.orderNumber="",
          vm.paidStatus="",
          vm.note = "" ,
          vm.discount = 0,
          vm.totalOrderPrice = 0
            console.log("Add Order Success");
            console.log(orderResult);
        }).catch(function(error){
            console.error('add(order) Error !');
            console.error(error);
        });
        vm.isLoading = false;;
    }
    else{
        alert("מספר הטלפון חייב להכיל 10 ספרות בלבד")
    }

      }
   
    else if(vm.fullname.length <= 0 || vm.dayOrder.length <= 0 || vm.timeOrder.length <= 0 || vm.dateOrder.length <= 0 || vm.paidStatus.length <= 0 ) {
        alert("חובה למלא את כל השדות!");
    }   
        
      },
      uploadImage(e){
        
        if(e.target.files[0]){
                let file = e.target.files[0];
                let storageRef = firebase.storage().ref('orders/' + file.name);
                let uploadTask = storageRef.put(file);
                uploadTask.on('state_changed', 
                (snapshot) => { 
                }, 
                (error) => {
                    // Handle unsuccessful uploads
                }, 
                () => {
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    this.orderImg.push(downloadURL);
                    let media = { 
                        date: new Date().toLocaleDateString(),
                        image: "",
                        fullname: this.fullname,
                        orderNumber : this.counter.orderNumber
                    }
                    media.image = downloadURL;
                    console.log(media);
                    db.collection("Media").add(media);
                    console.log('File available at', downloadURL);
                    });
                }
                );

            }

            
        },
        downloadFullExample() {
            const storageRef = firebase.storage().ref();

            // [START storage_download_full_example]
            // Create a reference to the file we want to download
            var starsRef = storageRef.child('orders/' + file.name);

            // Get the download URL
            starsRef.getDownloadURL()
            .then((url) => {
                // Insert url into an <img> tag to "download"
            })
            .catch((error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                case 'storage/object-not-found':
                    // File doesn't exist
                    break;
                case 'storage/unauthorized':
                    // User doesn't have permission to access the object
                    break;
                case 'storage/canceled':
                    // User canceled the upload
                    break;

                // ...

                case 'storage/unknown':
                    // Unknown error occurred, inspect the server response
                    break;
                }
            });
            // [END storage_download_full_example]
        },
        loadOrders(){
          let vm = this;
          vm.orders = [];
          db.collection("orders").orderBy("createdDate","desc").get()
          .then(function(orderResult){
                  for(let a = 0; a < orderResult.size; a++){
                      let orderId = orderResult.docs[a].id;
                      let order = orderResult.docs[a].data();
                      vm.orders.push({ ID: orderId, Data: order });
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
loadCounter() {
  let vm = this;
  db.collection("OrderCounter").doc("5NRGIhiE5QdVfWdstHOP").get()
    .then((doc) => {
      if (doc.exists) {
        vm.counter = doc.data();
        if (vm.counter.orderNumber < vm.min) {
          vm.counter.orderNumber = vm.min;
        } else {
          vm.counter.orderNumber++;
        }
      }
    })
    .catch((error) => {
      console.error("❌ خطأ في تحميل العداد:", error);
    });
},

      loadProductsToOrder(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'עוגות מרובעות').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadCircleCakes(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'עוגות עגולות').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadBiscuit(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'עוגיות').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadPasim(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'פסים').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadCoufsaot(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'קופסאות').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadMghashim(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'מגשים').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadOneUse(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'חד פעמי').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadDrinks(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'שתיה').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadHataifim(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'חטיפים').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      loadBakingCakes(){
          let vm = this;
          vm.activeProductsBar = 1 
          vm.Products = [];
          db.collection("Products").where('category', '==', 'שמרים').get().then((result)=>{
              for(let a = 0; a < result.size; a++){
                    let itemId = result.docs[a].id;
                    let item = result.docs[a].data();
                    // console.log(orderResult.size);
                    vm.Products.push({
                      ID : itemId,
                      Data : item
                      
                });
            }
            vm.totalProducts = result.size;

          }).catch((error)=>{
              console.log("Error Loading Products", error)
          })
      },
      addToArray(item){
        let vm = this;
        const existingItem = vm.cart.find((cartItem) => cartItem.ID === item.ID);
        if (existingItem) {
          vm.selectedQuantity++;
        } else {
            vm.cart.push(item);
        }
        // vm.cart.push(item);

        console.log(vm.cart);
        vm.totalOrderPrice += item.Data.Price;

        
        // vm.cart.forEach(product => {
        // vm.totalOrderPrice += product.Data.Price;
        // })
    },
    addToCart(item) {
        let selectedCount = 1;
      const existingItem = this.cart.find(cartItem => cartItem.ID === item.ID);
        this.productObj = item;
        console.log(this.productObj);
      if (existingItem) {
        existingItem.selectedCount++;
        let newQuantity = item.Data.Quantity - existingItem.selectedCount;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
      } else {
        this.cart.push({ ...item, selectedCount: 1 });
        let newQuantity = item.Data.Quantity - 1;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
      }
      this.totalOrderPrice += item.Data.Price;
      console.log(this.cart);
    },
    reduceItem(item,index) {
      const existingItem = this.cart.find(cartItem => cartItem.ID === item.ID);
      let selectedCount = 1;
      if (existingItem) {
        existingItem.selectedCount--;
        let newQuantity = item.Data.Quantity - existingItem.selectedCount;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        if( existingItem.selectedCount == 0){
            
            let newQuantity = item.Data.Quantity ;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
            this.cart.splice(index, 1);
        }
      this.totalOrderPrice -= item.Data.Price;
      console.log(this.cart);
        }
        else{
            let newQuantity = item.Data.Quantity - existingItem.selectedCount + 1;
            db.collection("Products").doc(item.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(item.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        }
    },
    removeItem(product,index) {
        let selectedCount = 1;
        if(product.selectedCount >= 1){
            let newQuantity = this.productObj.Data.Quantity ;
            console.log("Product Quantity :", product.Data.Quantity)
            console.log("Product Selected Quantity :", product.selectedCount)
            db.collection("Products").doc(product.ID).get()
            .then((order) =>{
                let orderData = order.data();
                orderData.Quantity = newQuantity;
                db.collection("Products").doc(product.ID).update(orderData);
                console.log("New Amoumt is :" + newQuantity) ;
                
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        }
            // else if(product.selectedCount < 1){
            //     let newQuantity = product.Data.Quantity + product.selectedCount;
            //     db.collection("Products").doc(product.ID).get()
            // .then((order) =>{
            //     let orderData = order.data();
            //     orderData.Quantity = newQuantity;
            //     db.collection("Products").doc(product.ID).update(orderData);
            //     console.log("New Amoumt is :" + newQuantity) ;
                
            // })
            // .catch((error) =>{
            //     console.log("Error :" , error);
            // })
            // }
      // Remove the item at the specified index from the array.
      this.cart.splice(index, 1);
      this.totalOrderPrice -= product.Data.Price * product.selectedCount;
    },
      
    }
    }

</script>
<style scoped>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.createOrder{
    padding: 0 1rem;
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative; */
    height: 100%;

}
.loadingModal{
    width: 100%;
    height: 100%;

    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 11111;
    position: fixed;
    right: 0;
    top: 0;
    background-color: rgba(0,0,0,0.2);
}
.loader{
    margin:  auto;
    border: 10px solid #EAF0F6;
    border-radius: 50%;
    border-top: 10px solid #00414d;
    width: 100px;
    height: 100px;
    animation: spinner 1s linear infinite;
    z-index: 100000;
}
@keyframes spinner {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.rightSide{
    width: 70%;
    float: right;
    min-height: 500px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: center;
    position: relative;
}
.leftSide{
    width: 30%;
    float: right;
    min-height: 500px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cartbox{
    width: 100%;
    min-height: 250px;
    position: absolute;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    top: 3.5rem;
    overflow: hidden;
}
.steps, .forward{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    height: 60px;
    overflow: hidden;
    margin-bottom: 10px;
}
.forward{
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 1rem;
}
.forward button{
    position: absolute;
    left: 1rem;
    padding: 8px 30px;
    border: 0;
    border-radius: 8px;
    background-color: #000;
    color: #fff;
    font-size: 14px;
}
.forward a{
    color: #666;
    text-decoration: none;
    font-size: 14px;
}
.subMenu{
    width: 100%;
    height: 60px;
    display: flex;
}
.listItem{
    display: flex;
    align-items: center;
    justify-content: center; 
    flex-grow: 2.5;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 14px;
    cursor: pointer;
}
.boxStyle{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    min-height: 100px;
    overflow: hidden;
    display: flex;
    padding: 1rem;
    margin-bottom: 10px;
}
.input-field-beta{
    width: calc(100% / 2);
    display: flex;
    flex-direction: column;
    margin: 0 10px;
}
.input-field-beta label{
    font-size: 12px;
    font-weight: 500;
    color: #707070;
}
.input-field-beta input,
.input-field-beta select
{
    font-size: 15px;
    padding: 7px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    color: #000;
    outline: none;
}
.input-field-beta select
{
    width: 100%;
}
.categories{
    width: 95%;
    background-color: #fff;
    min-height: 100px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 1rem;
}
.catHeader{
    padding-bottom: 1rem;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 1rem;
    position: relative;
}
.catHeader span{
    font-size: 18px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
}
.catHeader input{
    position: absolute;
    left: 0;
    width: 50%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    font-size: 14px;
}
.collection{
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: scroll;
}
.category{
    margin: 5px;
    height: 120px;
    background: transparent;
    border: 2px solid #00414d;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* .productsCollection{
    width: 100%;
    min-height: 200px;
    display: flex;
    align-items: top;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
} */
.product{
    min-width: 170px;
    min-height: 150px;
    background: transparent;
    border: 2px solid #00414d;
    border-radius: 2px;
    position: relative;
    text-align: center;
    padding: 1rem;
    margin: 5px;
    font-family:'Noto Sans Hebrew';
}
.cartHeader{
    padding: 1rem;
    background-color: #f9f9f9;
    color: #666;
    font-size: 15px;
    font-weight: 500;
}
.totalPrice{
    padding: 1rem;
    background-color: #f9f9f9;
    color: #666;
    font-size: 15px;
    font-weight: 500;
    width: 100%;
}
.selectedQuantity{
    color: #000;
    font-weight: 700;
    font-size: 16px;
    font-family: 'Noto Sans Hebrew';
}
.category span
{
    text-align: center;
    font-weight: 400;
    color: #000;
    font-size: 18px;
    /* background-color: #00414d; */
    width: 130px;
    padding: 10px;
    color: #000;
    font-family: 'Noto Sans Hebrew';
}
.productName{
    color: #000;
    font-size: 18px;
    font-weight: 600;
}
.productPrice{
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    font-size: 20px;
    font-weight: 600;
}
.productQuantity{
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    font-size: 18px;
    font-weight: 400;
    color:#666;
}
.ProductLine{
    padding: 1rem;
    font-size: 14px;
    font-weight: 500;
    color: #666;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
}
.ProductLine .price{
    position: absolute;
    left: 1rem;
    color: #1c1c1c;
    font-weight: 700;
}
.discountLabel{
    width: 100%;
    margin-bottom: 1rem;
}
.discountLabel label{
    display: block;
    font-size: 13px;
}
.discountLabel input{
    width: 100%;
    padding: 0.5rem 1rem ;
    font-size: 13px;
    border-radius: 4px;
    border: #ddd 1px solid ;
}
.total{
    position: absolute;
    left: 1rem;
    color: #000;
}
.tools{
    width: 100%;
    min-height: 30px;
    background-color: transparent;
    margin-top: 10px;
    display: flex;
    align-items: center;
}
.tools ul{
    width: 100%;
}
.tools ul li{
    display: inline-block;
    padding: 0 20px;
    list-style: none;
}
.tools ul .removeBtn{
    float:right;
    background-color: #b91c1c;
    color:#fff;
    width:30px;
    height:30px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .increaseBtn,
.tools ul .reduceBtn{
    float:left;
    background-color:aliceblue;
    color:#fff;
    font-size:22px;
    width: 30px;
    height: 30px;
    display:flex;
    align-items:center;
    justify-content:center;
    margin-right:10px;
    border-radius:2px;
    padding: 5px 0 ;
    cursor:pointer;
}
.tools ul .removeBtn span{
    font-size:22px;
}
.tools ul .increaseBtn span,
.tools ul .reduceBtn span{
    font-size:22px;
    color:#000;
}
.header{
    padding: 1rem;
    /* border-bottom: 1px solid #f5f5f5; */
    text-align: right;
    position: relative;
    width: 95%;
}
.header span{
    font-size: 16px;
    color: #666;
    font-weight: 700;
    text-align: right;
}
.header .orderNum{
    position: absolute;
    left: 1rem;
}
.activeItem{
    background-color: #00414d;
    color: #fff;
}
.uploadedPhotos{
    width: 95%;
    border: 1px solid #e0e0e0;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 10px;
}
.photosHeader{
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 1rem;
    font-size: 16px;
    font-weight: 500;
    color: #000;
}
.photos{
    padding: 1rem;
  }
  .photos img{
    width: 25%;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    float: right;
  }
  .sendOrderBtn{
    background-color: cadetblue;
  }
  .selectPayment{
    width: calc(100% / 2 - 10px );
    padding: 1rem;
    border-radius: 4px;
    border: 1px solid #dfdfdf;
    background-color: #fcfcfc;
    min-height: 50px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    text-align: center;
  }
  .noteField{
    width: 100%;
  }
  .noteField textarea{
    width: 100%;
    min-height: 100px;
    max-height: 100px;
    padding: 0.5rem;
    border: 2px solid #FEBE10;
    border-radius: 8px;
    margin-top: 10px;
    background-color: #ffff;
    resize: none; 
  }
  .paymentStyle{
    width: 95%;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    min-height: 100px;
    overflow: hidden;
    padding: 1rem;
    margin-bottom: 10px;
  }
  .paymentStyle .title{
    width: 100%;
    display: block;
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
  }
  .paymentDiv{ 
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .selectPayment input{
    width: 30px;
    height: 30px;
  }
  .selectPayment i{
    font-size: 35px;
    color: #43b9cf;
    margin-right: 20px;
  }
  .selectPayment .paymentText{
    font-size: 22px;
    color: #43b9cf;
    margin-right: 20px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
  }
  @media screen and (max-width:500px){
    *{
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }
    .createOrder{
    padding: 0 1rem;
}
.rightSide{
    width: 100%;
    float: left;
    min-height: 100px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: center;
    position: relative;
    margin-right: -2rem;
}
.leftSide{
    width: 100%;
    float: left;
    min-height: 2000px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: -2rem;
}
.steps, .forward{
    width: 100%;
  }
.listItem{
    font-weight: 400;
    font-size: 13px;
    text-align: center;
}
.boxStyle{
    width:100%;
    display: block;
}
.input-field-beta{
    width: 100%;
    margin:  10px 0;
    display: block;
}
.input-field-beta label{
    font-size: 12px;
    font-weight: 500;
    color: #707070;
    display: block;
}
.input-field-beta input,
.input-field-beta select
{
    width: 100%;
    font-size: 13px;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    color: #000;
    outline: none;
    -webkit-appearance:none;
}
.categories{
    width: 100%;
    background-color: #fff;
    min-height: 100px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 1rem;
}
.catHeader{
    padding-bottom: 1rem;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 1rem;
}
.catHeader span{
    font-size: 18px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
}
.collection{
    width: 100%;
}

.category{
    margin: 5px;
    padding: 1rem;
    height: 120px;  
    float: right;
}
.paymentStyle{
    width: 100%;
  }
.productsCollection{
    width: 100%;
}
.productName, .productPrice, .productQuantity{
    font-size: 16px;
}
.paymentDiv{ 
    width: 100%;
    display: block;
}
.selectPayment{
    width: 100%;
  }
  .selectPayment input{
    width: 30px;
    height: 30px;
  }
  .selectPayment i{
    font-size: 24px;
    color: #43b9cf;
    margin-right: 15px;
  }
  .selectPayment .paymentText{
    font-size: 17px;
    color: #43b9cf;
    margin-right: 15px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
  }
.uploadedPhotos{
    width: 100%;
    border: 1px solid #e0e0e0;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 10px;
}
}
@media screen and (max-width:360px){
    .createOrder{
    padding: 0 1rem;
}
.rightSide{
    width: 100%;
    float: left;
    min-height: 100px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: center;
    position: relative;
    margin-right: -2rem;
}
.leftSide{
    width: 100%;
    float: left;
    min-height: 2000px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: -2rem;
}
.steps, .forward{
    width: 100%;
  }
.listItem{
    font-weight: 400;
    font-size: 13px;
    text-align: center;
}
.boxStyle{
    width:100%;
    display: block;
}
.input-field-beta{
    width: 100%;
    margin:  10px 0;
    display: block;
}
.input-field-beta label{
    font-size: 12px;
    font-weight: 500;
    color: #707070;
    display: block;
}
.input-field-beta input,
.input-field-beta select
{
    width: 100%;
    font-size: 13px;
    padding: 4px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    color: #000;
    outline: none;
}
.uploadedPhotos{
    width: 100%;
    border: 1px solid #e0e0e0;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 10px;
}
.paymentStyle{
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/CreateOrderBeta.vue